
import { useEffect, useState } from 'react'
import i18n from '../../Lang'

export const LanguageDataDDL = (props) => {
    const { Language, setLanguage } = props
   let LanguageChange =  localStorage.getItem('LanguageChange')

    const [LanguageID, setLanguageID] = useState(LanguageChange == 'English' ? true : false)

    const LanguageData = [
        {
            id: 1,
            lang: "Marathi",
        },
        {
            id: 2,
            lang: "English",
        },
    ]

    useEffect(() => {
        i18n.changeLanguage(Language.Label)
    }, [Language.Label])

    useEffect(() => {
        handleI18Next()
    }, [LanguageID])

    const handleI18Next = (e) => {
       
        setLanguage({ ...Language, ID: 0, Label: LanguageID ? 'English' : 'Marathi' })
        localStorage.setItem("LanguageChange", LanguageID ? 'English' : 'Marathi')
    }

    const handleLanguageDDL = () => {
        if (LanguageData && LanguageData.length > 0) {
            let list = LanguageData.map((item, index) => ({
                value: item.id,
                label: item.lang,
            }))

            setLanguage({
                DDL: list,
                ID: list[0].value,
                Label: list[0].label,
            })
        }
        else {
            setLanguage({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
          
            <span className='cursor-pointer '>
                <i class="fa-solid fa-globe text-blue"></i>
                <span className='text-blue mx-2' onClick={() => setLanguageID(!LanguageID)} >{LanguageID ? 'मराठी' : 'English'}</span>
            </span>
          
        </div>
    )
}